import { useForm } from "react-hook-form";
import { useDeleteUserAccount } from "@src/entities/user";
import { InputField } from "@src/shared/ui/InputField";
import { Button, IconButton, InputAdornment } from "@mui/material";
import { backButtonStyles, saveBtnStyles } from "../constants";
import { yupResolver } from "@hookform/resolvers/yup";
import { accountDeletionStep3Schema } from "./constants";
import { ArrowBack, Visibility, VisibilityOff } from "@mui/icons-material";
import { userАccountСhangesStore } from "@src/entities/user/model/store/userАccountСhangesStore";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import styles from "./AccountDeletionStep3.module.scss";

interface AccountDeletionStep3Props {
  password: string;
}

interface Props {
  setStep: (step: number) => void;
}

export const AccountDeletionStep3 = ({ setStep }: Props) => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const { mutate: deleteUserAccount } = useDeleteUserAccount();
  const deletedUserAccountInfo = userАccountСhangesStore(
    (state) => state.userАccountСhangesInfo
  );

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<AccountDeletionStep3Props>({
    defaultValues: {
      password: "",
    },
    resolver: yupResolver(accountDeletionStep3Schema) as any,
  });

  const onSubmit = (data: AccountDeletionStep3Props) => {
    const params = { ...deletedUserAccountInfo, password: data.password };
    deleteUserAccount(params, {
      onSuccess: () => {
        navigate("/login");
      },
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
      <InputField
        control={control}
        name="password"
        label="Текущий пароль"
        className={styles.inputField}
        type={showPassword ? "text" : "password"}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  sx={{ color: "#a4bbc740", mr: 1 }}
                  onClick={() => setShowPassword((show) => !show)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
      <Button
        type="submit"
        variant="contained"
        disabled={!isValid}
        sx={saveBtnStyles}
      >
        Сохранить
      </Button>
      <Button
        variant="text"
        onClick={() => setStep(1)}
        sx={backButtonStyles}
        type="button"
        startIcon={<ArrowBack />}
      >
        Вернуться
      </Button>
    </form>
  );
};
